import { render, staticRenderFns } from "./ThirdPartySoft.vue?vue&type=template&id=6bd00e46&scoped=true"
import script from "./ThirdPartySoft.vue?vue&type=script&lang=js"
export * from "./ThirdPartySoft.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartySoft.vue?vue&type=style&index=0&id=6bd00e46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd00e46",
  null
  
)

export default component.exports